export default __webpack_public_path__ + "static/media/30-ISO-Approval-Celebration.6a60b1e4.jpg";